// export const serverIP = '47.97.192.100'
//    // export const serverIP = 'localhost'


export const serverIP = '/cmekgdti-api/'
// export const serverIP = 'http://localhost:9013/'



//////////////////
// WEBPACK FOOTER
// ./public/config.js
// module id = t3uW
// module chunks = 6